var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticStyle:{"width":"100%","text-align":"center"}},[_c('img',{staticStyle:{"max-height":"35px"},attrs:{"src":"/img/loading.gif"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }